import { images } from "./product";
import type { Volume } from "../types/product";

// I 6 volumi del bundle: inserisci titoli, numero di ricette, descrizioni e contenuti definitivi.
// "count" è facoltativo: se lo lasci vuoto, il numero di ricette non viene mostrato.
// "items" è facoltativo: elenco dei prodotti o contenuti del volume (es. "Burri corpo montati").
export const volumes: Volume[] = [
  {
    number: 1,
    title: "[Titolo del volume]",
    count: undefined,
    image: images.butters,
    description: "[Breve descrizione del volume: quali prodotti si imparano a preparare.]",
    items: [],
  },
  {
    number: 2,
    title: "[Titolo del volume]",
    count: undefined,
    image: images.soaps,
    description: "[Breve descrizione del volume: quali prodotti si imparano a preparare.]",
    items: [],
  },
  {
    number: 3,
    title: "[Titolo del volume]",
    count: undefined,
    image: images.lips,
    description: "[Breve descrizione del volume: quali prodotti si imparano a preparare.]",
    items: [],
  },
  {
    number: 4,
    title: "[Titolo del volume]",
    count: undefined,
    image: undefined,
    description: "[Breve descrizione del volume: quali prodotti si imparano a preparare.]",
    items: [],
  },
  {
    number: 5,
    title: "[Titolo del volume]",
    count: undefined,
    image: undefined,
    description: "[Breve descrizione del volume: quali prodotti si imparano a preparare.]",
    items: [],
  },
  {
    number: 6,
    title: "[Titolo del volume]",
    count: undefined,
    image: undefined,
    description: "[Breve descrizione del volume: quali prodotti si imparano a preparare.]",
    items: [],
  },
];
